import { render, staticRenderFns } from "./PropertiesSold.vue?vue&type=template&id=c0687dca&scoped=true&"
import script from "./PropertiesSold.vue?vue&type=script&lang=ts&"
export * from "./PropertiesSold.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0687dca",
  null
  
)

export default component.exports